import { BucketVendor } from "@prequel/react";

// Fields set by the magic link and locked in the form
const FIXED_FIELDS = [
  "name",
  "vendor",
  "host",
  "bucket_vendor",
  "storage",
  "bucket_name",
  "container_name",
  "storage_account_name",
  "metastore",
  "project_id",
];

// Iceberg catalogs whose only storage option is S3
const S3_ONLY_CATALOGS = ["catalog_glue", "catalog_s3_tables"];

// Catalog is also a free-text Databricks field, so only lock it when the magic link sets it
export const isFixedField = (fieldName: string, catalog?: string): boolean =>
  fieldName === "catalog" ? !!catalog : FIXED_FIELDS.includes(fieldName);

// New API version prefixes the bucket vendor with bucket_
export const getBucketVendor = (bucketVendor?: string, catalog?: string): BucketVendor | undefined => {
  if (bucketVendor) {
    return ("bucket_" + bucketVendor) as BucketVendor;
  }
  return catalog && S3_ONLY_CATALOGS.includes(catalog) ? "bucket_s3" : undefined;
};
